module.exports = __webpack_public_path__ + "img/fte_metadata.f6f4759b.png";